import apiClient from '../../shared/services/apiClient';

/** A domain's own contacts + registrant email verification. Saving uses domainRegistrationService.updateContacts. */
const call = async (p) => {
    try {
        const r = await p;
        return r.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

const domainContactsService = {
    get: (id) => call(apiClient.get(`/api/user/domains/${id}/contacts`)),
    resendVerification: (id) => call(apiClient.post(`/api/user/domains/${id}/verification/resend`)),
    checkVerification: (id) => call(apiClient.post(`/api/user/domains/${id}/verification/check`)),
};

export default domainContactsService;
